import styled from '../../../../styles/theme';
import StockModelCardHeaderTemplate from './StockModelCardHeaderTemplate';
import { rem } from 'polished';

export const StockModelCardHeaderStyled = styled(StockModelCardHeaderTemplate)`
    position: relative;
    z-index: 10;

    .carMarketingSticker {
        text-align: right;

        .infoText {
            text-align: left;
        }
    }

    .title-flexWrapper {
        display: flex;
        align-items: baseline;
        position: relative;
        text-transform: uppercase;
    }

    .stockModelCard-header {
        padding: ${rem('20px')} ${rem('20px')} 0;
        margin-bottom: ${rem('5px')};
        position: relative;

        &--heading {
            font-weight: ${({ theme, isStockSlice }) =>
                isStockSlice ? theme.fontWeights.textRegular : theme.fontWeights.textBold};
            font-size: ${({ theme }) => theme.fontSizes.textBig};
            line-height: 1.5;
            font-style: normal;
            font-family: ${({ theme }) => theme.fonts.fontBase};
            .specPack {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }
        }

        &--info {
            display: flex;
        }

        &--engineInfo {
            margin-top: ${rem('5px')};
            color: ${({ theme }) => theme.colors.secondary};
            font-size: ${({ theme }) => theme.fontSizes.h7};

            & span {
                text-transform: uppercase;

                &:not(:first-of-type) {
                    &::before {
                        content: '|';
                        display: inline-block;
                        margin: 0 ${rem('3px')};
                        color: ${({ theme }) => theme.colors.grey11};
                    }
                }
            }
        }

        &--stockCount {
            margin-left: auto;
        }

        &--allModelCount {
            margin-left: auto;
        }
    }

    .lastItem {
        background-color: ${({ theme }) => theme.colors.deepPurple};
        color: ${({ theme }) => theme.colors.white};
        padding: ${rem('5px')} ${rem('10px')};
        position: absolute;
        right: ${rem('-35px')};
        top: ${rem('-20px')};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${rem('13px')};

        &::after {
            background-color: ${({ theme }) => theme.colors.shadePurple};
            position: absolute;
            content: '';
            width: ${rem('20px')};
            height: ${rem('20px')};
            top: ${rem('14px')};
            right: ${rem('5px')};

            transform: rotate(45deg);
            z-index: -1;
        }

        &::before {
            background-color: ${({ theme }) => theme.colors.white};
            position: absolute;
            content: '';
            width: ${rem('15px')};
            height: ${rem('15px')};
            top: ${rem('24px')};
            right: ${rem('15px')};

            transform: rotate(0deg);
            z-index: 0;
        }
    }

    .stockModelCard-separator {
        margin: 0 ${rem('15px')};
    }
`;
